define(["log",
        "jquery",
        "./kendo.virtuallist",
        "./kendo.filtercell",
        "./kendo.datepicker",
        "./kendo.datetimepicker",
        "./kendo.grid",
        "./kendo.upload",
        "./kendo.timepicker",
        "./kendo.combobox",
        "./kendo.slider",
        "./kendo.maskedtextbox",
        "./kendo.treelist",
        "./kendo.panelbar",
        "./kendo.autocomplete",
        "./kendo.tooltip",
        "./kendo.excel",
        "./kendo.notification",
        "./kendo.tabstrip",

        /*"./kendo.mobile.scrollview",        
        "./kendo.mobile.switch",
        "./kendo.mobile.button",*/

        "./kendo.mobile.application",
        "./kendo.mobile.buttongroup",
        "./kendo.mobile.collapsible",
        "./kendo.mobile.drawer",
        "./kendo.mobile.listview",
        "./kendo.mobile.loader",
        "./kendo.mobile.modalview",
        "./kendo.mobile.navbar",
        "./kendo.mobile.pane",
        "./kendo.mobile.popover",
        "./kendo.mobile.scroller",
        "./kendo.mobile.scrollview",
        "./kendo.mobile.shim",
        "./kendo.mobile.splitview",
        "./kendo.mobile.switch",
        "./kendo.mobile.tabstrip",
        "./kendo.mobile.view",


        "./kendo.touch",
        "./kendo.toolbar",
        "./kendo.listview",
        "./kendo.treeview",
        "./kendo.treelist",
        "./kendo.dataviz.chart",
        "./kendo.dataviz.stock",
        "./kendo.multiselect"], function (log) {

    log.log("kendo plugins loaded");

    return window.kendo;
});

require(["kendo"], function (kendo) {
    kendo.ns = "kendo-";
});



//////////////////
// WEBPACK FOOTER
// ./kendo/_kendo.build.js
// module id = 17
// module chunks = 2